import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const isLoading = createSlice({
  name: 'isLoading',
  initialState,
  reducers: {
    startLoading: handlers.startLoading,
    endLoading: handlers.endLoading,
  },
});

export const { actions, reducer } = isLoading;

export const { startLoading, endLoading } = actions;

export default reducer;
